<template>
  <main :key="componentKey">
    <!-- <button @click="test">holens</button> -->
    <div>
      <h4 class="">Actualizador Masivo De Membresías</h4>
    </div>
    <div class="pb-1 d-flex">
      <p
        class="bg-info px-3 mb-0 rounded-pill text-light py-0"
        slot="title-label"
        type="info"
      >
        Paso 1
      </p>
      <i
        class="fa fa-question-circle pointer fa-lg text-info my-auto ml-2"
        aria-hidden="true"
        @click="showInfo(1)"
      ></i>
    </div>
    <filters
      ref="filtersComponent"
      @filter="handleUpdateFilters"
      :plansCatalog.sync="plansCatalog"
      :statusCatalog.sync="statusCatalog"
      :familiesCatalog.sync="familiesCatalog"
      :subFamiliesCatalog.sync="subFamiliesCatalog"
      :shiftsCatalog.sync="shiftsCatalogFromMemberships"
      @currentFilters="handleUpdateCurrentFilters"
      @export="handleExportSelection"
    ></filters>
    <div class="pb-2 d-flex">
      <p
        class="bg-info px-3 mb-0 rounded-pill text-light py-0"
        slot="title-label"
        type="info"
      >
        Paso 2
      </p>
      <i
        class="fa fa-question-circle pointer fa-lg text-info my-auto ml-2"
        aria-hidden="true"
        @click="showInfo(2)"
      ></i>
    </div>
    <memberships-table
      ref="membershipsTable"
      :tableData.sync="showingMemberships"
      :totalMemberships.sync="filteredMembershipsCount"
      @fetchData="handleFetchByScroll"
      @emitEditExclusion="updatedCurrentEditExclusion"
      @refresh="refreshTable"
      @activateEditor="activateEditor"
      :isSync.sync="tableIsUpdated"
    ></memberships-table>
    <SlideYUpTransition :duration="1000">
      <div class="pb-2 d-flex" v-if="showEditor">
        <p
          class="bg-info px-3 mb-0 rounded-pill text-light py-0"
          slot="title-label"
          type="info"
        >
          Paso 3
        </p>
        <i
          class="fa fa-question-circle pointer fa-lg text-info my-auto ml-2"
          aria-hidden="true"
          @click="showInfo(3)"
        ></i>
      </div>
    </SlideYUpTransition>
    <SlideYUpTransition :duration="1000">
      <memberships-edit
        ref="editorComponent"
        v-if="showEditor"
        @toggleShiftSelect="toggleShiftSelect"
        :shiftName="
          selectedShift.descripcionTurno ? selectedShift.descripcionTurno : ''
        "
        :catalogDictionary.sync="catalogDictionary"
        @editSelectedShift="editSelectedShift"
        @continue="handleEditContinue"
        @updated="editDataUpdated"
      ></memberships-edit>
    </SlideYUpTransition>

    <SlideYUpTransition :duration="1000">
      <div class="pb-2 d-flex" v-if="showAlert">
        <p
          class="bg-info px-3 mb-0 rounded-pill text-light py-0"
          slot="title-label"
          type="info"
        >
          Paso 4
        </p>
        <i
          class="fa fa-question-circle pointer fa-lg text-info my-auto ml-2 font-weight-bold"
          aria-hidden="true"
          @click="showInfo(4)"
        ></i>
      </div>
    </SlideYUpTransition>

    <SlideYUpTransition :duration="1000">
      <alert
        ref="alertComponent"
        v-if="showAlert"
        :editInclusion.sync="currentEditInclusion"
        :filter.sync="currentQueryFilters"
        :totalFilter.sync="filteredMembershipsCount"
        :previewData.sync="previewData"
        :compareData.sync="compareData"
        @preview="previewSingle"
        @continue="handleBulkMembershipUpdate"
      ></alert>
    </SlideYUpTransition>
    <shift-select-modal
      ref="shiftSelectModal"
      @saveShiftSelection="handleSaveShiftSelection"
      @showNewShiftDetails="handleShowShiftDetails"
      :tableData.sync="shiftsCatalog"
      @closed="shiftSelectModalClose"
    ></shift-select-modal>
    <shift-update-modal
      :shiftData.sync="selectedShift"
      ref="shiftUpdateModal"
      @disableEdit="disableShiftEdit"
      @stepBack="shiftUpdateModalStepBack"
      @closed="shiftUpdateModalClose"
      @saveChanges="shiftHandleSaveChanges"
    ></shift-update-modal>
  </main>
</template>

<script>
import _ from "lodash";
import XLSXpopulate from "xlsx-populate";
import Filters from "./MembreshipsAdm/Filters.vue";
import MembershipsEdit from "./MembreshipsAdm/MembershipsEdit.vue";
import MembershipsTable from "./MembreshipsAdm/MembershipsTable.vue";
import Alert from "./MembreshipsAdm/Alert.vue";
import ShiftSelectModal from "./MembreshipsAdm/ShiftSelectModal.vue";
import ShiftUpdateModal from "./MembreshipsAdm/ShiftUpdateModal.vue";
import { SlideYUpTransition } from "vue2-transitions";
import {
  Badge,
  Modal,
  CollapseItem,
  Collapse,
} from "src/components/UIComponents";
export default {
  components: {
    Filters,
    MembershipsEdit,
    MembershipsTable,
    Alert,
    SlideYUpTransition,
    ShiftSelectModal,
    ShiftUpdateModal,
    Badge,
  },
  data() {
    return {
      componentKey: 0,
      editData: null,
      shiftUpdate: false,
      selectedShift: {},
      showEditor: false,
      showAlert: false,
      tableIsUpdated: false,
      plansCatalog: [],
      familiesCatalog: [],
      subFamiliesCatalog: [],
      shiftsCatalogFromMemberships: [],
      shiftsCatalog: [],
      statusCatalog: [],
      catalogDictionary: {},
      queryFilters: {
        status: [],
        plan: [],
        family: [],
        subFamily: [],
        branches: [],
        shift: [],
      },
      currentQueryFilters: {
        status: [],
        plan: [],
        family: [],
        subFamily: [],
        branches: [],
        shift: [],
      },
      currentEditInclusion: {
        editAll: false,
        editList: [],
      },
      branches: [],
      tableCurrentPage: 0,
      filteredMembershipsCount: 0,
      showingMemberships: [],
      keepFetchingData: true,
      previewData: {},
      compareData: {},
      reportData: [],
    };
  },
  watch: {},
  methods: {
    async test(arg) {
      // console.log("Filtranding");
      // console.log(this.selectedShift);
      // await this.createReportData();
      await this.renderAMMBackup();
    },
    showInfo(opt) {
      const swalDefault = {
        confirmButtonColor: `#6bd098`,
        icon: "info",
        iconHtml: '<i class="fa fa-question" aria-hidden="true"></i>',
      };
      switch (opt) {
        case 1:
          this.$swal
            .fire({
              html: "<p>Utiliza los filtros disponibles para refinar los resultados que desees modificar o exportar.</p>",
              ...swalDefault,
            })
            .then(() => {
              this.$swal
                .fire({
                  html: " </p>Puedes seleccionar múltiples criterios para precisar aún más la búsqueda, incluyendo familias, sub-familias, planes específicos, estados, sucursales, y rangos de fechas para inicio y vencimiento de las membresías.</p>",
                  ...swalDefault,
                })
                .then(() => {
                  this.$swal.fire({
                    html: `<p>Recuerda que puedes desplegar u ocultar los filtros adicionales  utilizando el botón <small class="bg-success px-2 py-1 rounded-pill text-nowrap text-light">MÁS FILTROS<i class="fa fa-plus ml-1" aria-hidden="true"></i></small>, esto te permitirá acceder a opciones más detalladas cuando sea necesario.</p>`,
                    ...swalDefault,
                  });
                });
            });
          break;
        case 2:
          this.$swal
            .fire({
              html: "<p>Este paso te permite revisar y seleccionar las membresías resultantes de los filtros aplicados.</p><p>Aquí puedes elegir cuáles de estas membresías deseas modificar en los siguientes pasos del proceso de actualización masiva.</p>",
              ...swalDefault,
            })
            .then(() => {
              this.$swal
                .fire({
                  html: "<p>Cada fila en la tabla representa una membresía. Utiliza el checkbox en la cabecera de la tabla para seleccionar o deseleccionar todas las membresías de manera simultánea. También puedes seleccionar individualmente las membresías que deseas modificar.</p>",
                  ...swalDefault,
                })
                .then(() => {
                  this.$swal
                    .fire({
                      html: "<p>Asegúrate de revisar cuidadosamente los detalles de cada membresía, como el nombre del socio, tipo de membresía, estado actual, y fecha de vencimiento antes de proceder.</p>",
                      ...swalDefault,
                    })
                    .then(() => {
                      this.$swal
                        .fire({
                          html: " </p>Si la información mostrada no está actualizada o deseas refrescar los datos para asegurarte de que son recientes, utiliza el botón de actualizar.<p></p>Esto es especialmente importante para mantener la coherencia de los datos antes de realizar cambios significativos.</p>",
                          ...swalDefault,
                        })
                        .then(() => {
                          this.$swal.fire({
                            html: `<p>Una vez estés satisfecho con la selección, puedes proceder al siguiente paso donde especificarás las modificaciones a aplicar a las membresías seleccionadas.<p></p>Recuerda, cualquier cambio realizado en esta etapa es crucial y puede afectar numerosos registros de membresías.</p>`,
                            ...swalDefault,
                          });
                        });
                    });
                });
            });
          break;
        case 3:
          this.$swal
            .fire({
              html: `<p>En este paso puedes especificar los cambios que deseas aplicar a las membresías seleccionadas. Configura el estado, turno, plan, y otros detalles relevantes de acuerdo a tus necesidades.</p>`,
              ...swalDefault,
            })
            .then(() => {
              this.$swal
                .fire({
                  html: `<p>Selecciona un <strong>Estado</strong> de la lista para actualizar el estado de todas las membresías seleccionadas, o cambia el <strong>Turno</strong> asociado a las membresías para ajustar su programación. Utiliza los selectores para especificar nuevas fechas de inicio y vencimiento, o ajusta las sesiones disponibles según sea necesario.</p>`,
                  ...swalDefault,
                })
                .then(() => {
                  this.$swal.fire({
                    html: `<p>Para realizar ajustes de valor o duración, elige entre aumentar, disminuir o establecer un valor fijo. Todos los campos ofrecen la flexibilidad de aplicar cambios en porcentajes o montos fijos, asegurando que puedes adaptar cada membresía a los requerimientos específicos de tu gestión.</p>
               <p>Una vez hayas configurado todos los cambios, revisa cuidadosamente antes de proceder al último paso donde podrás confirmar y aplicar las modificaciones de forma masiva a las membresías seleccionadas.</p>`,
                    ...swalDefault,
                  });
                });
            });
          break;
        case 4:
          this.$swal
            .fire({
              html: `<p class="font-weight-bold">¡Precaución antes de proceder!</p><p>Estás en el último paso antes de realizar cambios significativos en las membresías. Este paso te permite revisar y confirmar todos los cambios propuestos.</p>`,
              ...swalDefault,
            })
            .then(() => {
              this.$swal
                .fire({
                  html: `<p>Utiliza la sección <strong>PREVISUALIZAR</strong> para verificar los detalles específicos de cada cambio aplicado a las membresías seleccionadas. Asegúrate de que cada ajuste es correcto y cumple con las necesidades identificadas.</p>`,
                  ...swalDefault,
                })
                .then(() => {
                  this.$swal
                    .fire({
                      html: `<p><strong>Confirmación Final:</strong> Antes de continuar, revisa que todos los cambios están correctamente configurados y que has previsualizado las membresías afectadas para evitar errores.</p>`,
                      confirmButtonText: "Continuar",
                      ...swalDefault,
                    })
                    .then((result) => {
                      if (result.isConfirmed) {
                        this.$swal
                          .fire({
                            html: `<p>Al pulsar <strong>Continuar</strong>, se te presentará una casilla de verificación para confirmar que aceptas la responsabilidad por las modificaciones realizadas.</p>`,
                            confirmButtonText: "Continuar",
                            ...swalDefault,
                          })
                          .then((result) => {
                            if (result.isConfirmed) {
                              this.$swal.fire({
                                html: `<p>Al marcar la casilla y confirmar, se generará automáticamente un archivo Excel como respaldo que incluye el estado previo de las membresías afectadas. Este paso es vital para asegurar que tienes un registro antes de aplicar los cambios definitivos.</p>
                        <p>Una vez descargado el archivo de respaldo, se procederá con la actualización masiva de las membresías de manera irreversible.</p>`,
                                confirmButtonText: "Continuar",
                                ...swalDefault,
                              });
                            }
                          });
                      }
                    });
                });
            });
          break;

        default:
          break;
      }
    },
    editDataUpdated() {
      const alertComponent = this.$refs.alertComponent;
      if (alertComponent) {
        alertComponent.close();
        this.$nextTick(() => {
          this.showAlert = false;
        });
      }
    },
    cleanString(input) {
      const pattern = /[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ.,\s-]/g;
      return input.replace(pattern, "").trim(); // Elimina caracteres que no cumplen con el patrón
    },
    cleanNum(input) {
      const pattern = /[^0-9]/g;
      return input.replace(pattern, "").trim();
    },
    cleanEmail(input) {
      const pattern = /[^a-zA-Z0-9.@\-_]+/g;
      return input.replace(pattern, "").trim();
    },
    async renderAMMBackup() {
      this.$swal.fire({
        title: "Creando Copia De Seguridad",
        text: "Esto puede tardar un poco...",
        icon: "info",
        iconHtml: `<i class="fa fa-spinner fa-pulse fa-fw"></i><span class="sr-only">Loading...</span>`,
        showConfirmButton: false,
        allowOutsideClick: false,
      });
      let data;
      const user = sessionStorage.getItem("WHbUjdv3TG");
      let template;
      try {
        template = await this.fetchExcelTemplate(
          "respaldoActualizacionMasivaDeMembresias"
        );
      } catch (error) {
        console.error(error);
        await this.$swal
          .fire({
            title: "Error!",
            text: "Ha ocurrido un error durante la recuperación del template",
            icon: "error",
            confirmButtonColor: "#6bd098",
          })
          .then(() => {
            return { completed: false };
          });
      }
      if (!template || template.error) {
        await this.$swal
          .fire({
            title: "Error!",
            text:
              template.error ||
              "Ha ocurrido un error durante la recuperación del template",
            icon: "error",
            confirmButtonColor: "#6bd098",
          })
          .then(() => {
            return { completed: false };
          });
      }
      try {
        data = await this.createReportData(true);
      } catch (error) {
        console.error(error);
        await this.$swal.fire({
          title: "Error!",
          text:
            "Ha ocurrido un error mientras se recuperaba la información: " +
            error.message,
          icon: "error",
          confirmButtonColor: "#6bd098",
        });
      }
      if (!data || data.error) {
        await this.$swal
          .fire({
            title: "Error!",
            text:
              data.error ||
              "Ha ocurrido un error mientras se recuparaba la información",
            icon: "error",
            confirmButtonColor: "#6bd098",
          })
          .then(() => {
            return { completed: false };
          });
      }
      try {
        await XLSXpopulate.fromDataAsync(template)
          .then((wb) => {
            wb.sheet(1)
              .cell("D3")
              .value(this.$moment().format("DD/MM/YYYY - HH:mm:ss"));
            wb.sheet(1).cell("G3").value(user);
            data.forEach((customer, index) => {
              wb.sheet(1)
                .cell(`C${index + 7}`)
                .value(parseInt(index + 1));
              if (
                customer.informacionAdicional &&
                customer.informacionAdicional.contrato
              ) {
                wb.sheet(1)
                  .cell(`D${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.informacionAdicional.contrato}`
                    )
                  );
              }
              if (customer.nombreSocio) {
                wb.sheet(1)
                  .cell(`E${index + 7}`)
                  .value(this.cleanString(`${customer.nombreSocio}`));
              }
              if (customer.rut) {
                wb.sheet(1)
                  .cell(`F${index + 7}`)
                  .value(this.cleanString(`${customer.rut}`));
              }
              if (customer.sexo) {
                wb.sheet(1)
                  .cell(`G${index + 7}`)
                  .value(this.cleanString(`${customer.sexo}`));
              }
              if (
                customer.informacionGeografica &&
                customer.informacionGeografica.direccion
              ) {
                wb.sheet(1)
                  .cell(`H${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.informacionGeografica.direccion}`
                    )
                  );
              }
              if (
                customer.informacionGeografica &&
                customer.informacionGeografica.ciudad
              ) {
                wb.sheet(1)
                  .cell(`I${index + 7}`)
                  .value(
                    this.cleanString(`${customer.informacionGeografica.ciudad}`)
                  );
              }
              if (
                customer.informacionGeografica &&
                customer.informacionGeografica.region
              ) {
                wb.sheet(1)
                  .cell(`J${index + 7}`)
                  .value(
                    this.cleanString(`${customer.informacionGeografica.region}`)
                  );
              }
              if (
                customer.informacionAdicional &&
                customer.informacionAdicional.comuna
              ) {
                wb.sheet(1)
                  .cell(`K${index + 7}`)
                  .value(
                    this.cleanString(`${customer.informacionAdicional.comuna}`)
                  );
              }
              if (
                customer.informacionContacto &&
                customer.informacionContacto.telefonoFijo
              ) {
                wb.sheet(1)
                  .cell(`L${index + 7}`)
                  .value(
                    parseInt(
                      this.cleanNum(
                        `${customer.informacionContacto.telefonoFijo}`
                      )
                    )
                  );
              }
              if (
                customer.informacionContacto &&
                customer.informacionContacto.celular
              ) {
                wb.sheet(1)
                  .cell(`M${index + 7}`)
                  .value(
                    parseInt(
                      this.cleanNum(`${customer.informacionContacto.celular}`)
                    )
                  );
              }
              if (customer.autenticacion && customer.autenticacion.email) {
                wb.sheet(1)
                  .cell(`N${index + 7}`)
                  .value(this.cleanEmail(`${customer.autenticacion.email}`));
              }
              if (customer.perfilCuenta && customer.perfilCuenta.glosa) {
                wb.sheet(1)
                  .cell(`O${index + 7}`)
                  .value(this.cleanString(`${customer.perfilCuenta}`));
              }
              if (
                customer.informacionAdicional &&
                customer.informacionAdicional.rutTitularConvenio
              ) {
                wb.sheet(1)
                  .cell(`P${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.informacionAdicional.rutTitularConvenio}`
                    )
                  );
              }
              if (customer.fechaInscripcion) {
                wb.sheet(1)
                  .cell(`Q${index + 7}`)
                  .value(
                    customer.fechaInscripcion
                      ? this.$moment(customer.fechaInscripcion).toDate()
                      : this.$moment("01-01-1900").toDate()
                  );
              }
              if (
                customer.informacionAdicional &&
                customer.informacionAdicional.accesoFicha
              ) {
                wb.sheet(1)
                  .cell(`R${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.informacionAdicional.accesoFicha}`
                    )
                  );
              }
              if (
                customer.informacionAdicional &&
                customer.informacionAdicional.causaBloqueo
              ) {
                wb.sheet(1)
                  .cell(`S${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.informacionAdicional.causaBloqueo}`
                    )
                  );
              }
              if (
                customer.informacionAdicional &&
                customer.informacionAdicional.fechaNacimiento
              ) {
                wb.sheet(1)
                  .cell(`T${index + 7}`)
                  .value(
                    this.$moment(
                      customer.informacionAdicional.fechaNacimiento
                    ).toDate()
                  );
              }
              if (
                customer.informacionContacto &&
                customer.informacionContacto.facebook
              ) {
                wb.sheet(1)
                  .cell(`U${index + 7}`)
                  .value(
                    this.cleanString(`${customer.informacionContacto.facebook}`)
                  );
              }
              if (
                customer.informacionContacto &&
                customer.informacionContacto.instagram
              ) {
                wb.sheet(1)
                  .cell(`V${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.informacionContacto.instagram}`
                    )
                  );
              }
              if (
                customer.informacionContacto &&
                (customer.informacionContacto.twitter ||
                  customer.informacionContacto.linkedin)
              ) {
                wb.sheet(1)
                  .cell(`W${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.informacionContacto.twitter}`
                    ) ||
                      this.cleanString(
                        `${customer.informacionContacto.linkedin}`
                      )
                  );
              }

              if (customer.planes.principal) {
                wb.sheet(1)
                  .cell(`AK${index + 7}`)
                  .value(
                    this.cleanString(`${customer.planes.principal.convenio}`)
                  );
                wb.sheet(1)
                  .cell(`AL${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.planes.principal.nombreFamilia}`
                    )
                  );
                wb.sheet(1)
                  .cell(`AM${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.planes.principal.nombreSubFamilia}`
                    )
                  );
                wb.sheet(1)
                  .cell(`AN${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.planes.principal.descripcionPlan}`
                    )
                  );
                wb.sheet(1)
                  .cell(`AO${index + 7}`)
                  .value(
                    `${parseFloat(customer.planes.principal.valorPlan)}` || "0"
                  );
                wb.sheet(1)
                  .cell(`AP${index + 7}`)
                  .value(
                    customer.planes.principal.indicadorMatricula ? "SI" : "NO"
                  );
                // .value(customer.planes.principal.indicadorMatricula ? 1 : 0);
                wb.sheet(1)
                  .cell(`AQ${index + 7}`)
                  .value(parseFloat(customer.planes.principal.valorMatricula));
                if (customer.planes.principal.fechaUltimoPago) {
                  wb.sheet(1)
                    .cell(`AR${index + 7}`)
                    .value(
                      customer.planes.principal.fechaUltimoPago
                        ? this.$moment(
                            customer.planes.principal.fechaUltimoPago,
                            "DD-MM-YYYY"
                          ).toDate()
                        : this.$moment("01-01-1900").toDate()
                    );
                }
                wb.sheet(1)
                  .cell(`AS${index + 7}`)
                  .value(
                    parseFloat(customer.planes.principal.porcentajeDescuento) ||
                      0
                  );
                wb.sheet(1)
                  .cell(`AT${index + 7}`)
                  .value(
                    customer.planes.principal.indicadorFactura ? "SI" : "NO"
                  );
                wb.sheet(1)
                  .cell(`AU${index + 7}`)
                  // .value(customer.planes.principal.tipoIVA);
                  .value(
                    this.cleanString(`${customer.planes.principal.tipoIVA}`)
                  );
                wb.sheet(1)
                  .cell(`AV${index + 7}`)
                  .value(
                    this.cleanString(`${customer.planes.principal.estadoPago}`)
                  );
                wb.sheet(1)
                  .cell(`AW${index + 7}`)
                  .value(
                    customer.planes.principal.fechaAsignacion
                      ? this.$moment(
                          customer.planes.principal.fechaAsignacion
                        ).toDate()
                      : this.$moment("01-01-1900").toDate()
                  );
                // console.log("fechaInicio");
                // console.log(
                //   customer.planes.principal.fechaInicio || "sin datos"
                // );
                wb.sheet(1)
                  .cell(`AX${index + 7}`)
                  .value(
                    customer.planes.principal.fechaInicio
                      ? this.$moment(
                          customer.planes.principal.fechaInicio,
                          "DD-MM-YYYY"
                        ).toDate()
                      : this.$moment("01-01-1900").toDate()
                  );
                // console.log("vencimiento");
                // console.log(
                //   customer.planes.principal.fechaVencimiento || "sin datos"
                // );
                wb.sheet(1)
                  .cell(`AY${index + 7}`)
                  .value(
                    customer.planes.principal.fechaVencimiento
                      ? this.$moment(
                          customer.planes.principal.fechaVencimiento,
                          "DD-MM-YYYY"
                        ).toDate()
                      : this.$moment("01-01-1900", "DD-MM-YYYY").toDate()
                  );
                // console.log("vigencia");
                // console.log(
                //   customer.planes.principal.fechaVigencia || "sin datos"
                // );
                wb.sheet(1)
                  .cell(`AZ${index + 7}`)
                  .value(
                    customer.planes.principal.fechaVigencia
                      ? this.$moment(
                          customer.planes.principal.fechaVigencia,
                          "DD-MM-YYYY"
                        ).toDate()
                      : this.$moment("01-01-1900").toDate()
                  );
                wb.sheet(1)
                  .cell(`BA${index + 7}`)
                  .value(
                    customer.planes.principal.fechaUltimoPago
                      ? this.$moment(
                          customer.planes.principal.fechaUltimoPago,
                          "DD-MM-YYYY"
                        ).toDate()
                      : this.$moment("01-01-1900")
                  );
                wb.sheet(1)
                  .cell(`BB${index + 7}`)
                  .value(
                    customer.planes.principal.horaUltimoPago || "00:00:00"
                  );
                wb.sheet(1)
                  .cell(`BC${index + 7}`)
                  .value(parseInt(customer.planes.principal.duracionPlan) || 0);
                wb.sheet(1)
                  .cell(`BD${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.planes.principal.unidadDuracionPlan}`
                    )
                  );
                wb.sheet(1)
                  .cell(`BE${index + 7}`)
                  .value(
                    customer.planes.principal.indicadorMesCalendario
                      ? "SI"
                      : "NO"
                  );
                wb.sheet(1)
                  .cell(`BF${index + 7}`)
                  .value(
                    customer.planes.principal.indicadorUsoSesiones ? "SI" : "NO"
                  );
                wb.sheet(1)
                  .cell(`BG${index + 7}`)
                  .value(
                    parseInt(customer.planes.principal.sesionesUtilizadas) || 0
                  );
                wb.sheet(1)
                  .cell(`BH${index + 7}`)
                  .value(
                    parseInt(customer.planes.principal.sesionesLimite) || 0
                  );
                wb.sheet(1)
                  .cell(`BI${index + 7}`)
                  .value(
                    customer.planes.principal.indicadorPermiteRenovar
                      ? "SI"
                      : "NO"
                  );
                wb.sheet(1)
                  .cell(`BJ${index + 7}`)
                  .value(
                    parseInt(customer.planes.principal.expiracionRenovacion) ||
                      0
                  );
                wb.sheet(1)
                  .cell(`BK${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.planes.principal.unidadExpiracionRenovacion}`
                    )
                  );
                wb.sheet(1)
                  .cell(`BL${index + 7}`)
                  .value(
                    parseInt(customer.planes.principal.diasPermitidoCongelar) ||
                      0
                  );
                wb.sheet(1)
                  .cell(`BM${index + 7}`)
                  .value(`${customer.planes.principal.turno.idTurno}` || "0");
                if (customer.planes.principal.sucursalUltimoPago) {
                  wb.sheet(1)
                    .cell(`BN${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.planes.principal.sucursalUltimoPago}`
                      )
                    );
                }
                if (customer.planes.principal.fechaHoraUltimoAcceso) {
                  wb.sheet(1)
                    .cell(`BO${index + 7}`)
                    .value(
                      customer.planes.principal.fechaHoraUltimoAcceso
                        ? this.$moment(
                            customer.planes.principal.fechaHoraUltimoAcceso,
                            "DD-MM-YYYY"
                          ).toDate()
                        : this.$moment("01-01-1900").toDate()
                    );
                }
                wb.sheet(1)
                  .cell(`BP${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.planes.principal.nombreSucursalAsignacion}`
                    )
                  );
                wb.sheet(1)
                  .cell(`BQ${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.planes.principal.nombreUsuarioAsignacion}`
                    )
                  );
              }
            });
            // const sheet = wb.sheet(1);
            // sheet.sheetProtection().password("@#soporte.2024");
            wb.outputAsync().then((blob) => {
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(
                  blob,
                  `Respaldo A.M.M. [${this.$moment().format(
                    "DD-MM-yyyy - HH-mm-ss"
                  )}].xlsx`
                );
              } else {
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = url;
                a.download = `Respaldo A.M.M. [${this.$moment().format(
                  "DD-MM-yyyy - HH-mm-ss"
                )}].xlsx`;
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
              }
              this.$swal.close();
            });
          })
          .catch((error) => {
            console.error(error);
            this.$swal
              .fire({
                title: "Error!",
                text:
                  error.message ||
                  "Ha ocurrido un error durante la renderización del respaldo",
                confirmButtonColor: "#6bd098",
                icon: "error",
              })
              .then(() => {
                return { completed: false };
              });
          });
      } catch (error) {
        this.$swal
          .fire({
            title: "Error!",
            text:
              error.message ||
              "Ha ocurrido un error durante la renderización del respaldo",
            confirmButtonColor: "#6bd098",
            icon: "error",
          })
          .then(() => {
            return { completed: false };
          });
      } finally {
        this.reportData = [];
      }
      return { completed: true };
    },
    async handleExportSelection() {
      this.$swal.fire({
        title: "Exportando membresías filtradas",
        text: "Esto puede tardar un poco...",
        icon: "info",
        iconHtml: `<i class="fa fa-spinner fa-pulse fa-fw"></i><span class="sr-only">Loading...</span>`,
        showConfirmButton: false,
        allowOutsideClick: false,
      });
      let data;
      // const user = sessionStorage.getItem("WHbUjdv3TG");
      let template;
      try {
        template = await this.fetchExcelTemplate(
          "ListaPersonas_SinUpdateAutomatico"
        );
      } catch (error) {
        console.error(error);
        await this.$swal
          .fire({
            title: "Error!",
            text: "Ha ocurrido un error durante la recuperación del template",
            icon: "error",
            confirmButtonColor: "#6bd098",
          })
          .then(() => {
            return { completed: false };
          });
      }
      if (!template || template.error) {
        await this.$swal
          .fire({
            title: "Error!",
            text:
              template.error ||
              "Ha ocurrido un error durante la recuperación del template",
            icon: "error",
            confirmButtonColor: "#6bd098",
          })
          .then(() => {
            return { completed: false };
          });
      }
      try {
        data = await this.createReportData(false);
      } catch (error) {
        console.error(error);
        await this.$swal.fire({
          title: "Error!",
          text:
            "Ha ocurrido un error mientras se recuperaba la información: " +
            error.message,
          icon: "error",
          confirmButtonColor: "#6bd098",
        });
      }
      if (!data || data.error) {
        await this.$swal
          .fire({
            title: "Error!",
            text:
              data.error ||
              "Ha ocurrido un error mientras se recuparaba la información",
            icon: "error",
            confirmButtonColor: "#6bd098",
          })
          .then(() => {
            return { completed: false };
          });
      }
      try {
        await XLSXpopulate.fromDataAsync(template)
          .then((wb) => {
            wb.sheet(1)
              .cell("D3")
              .value(this.$moment().format("DD/MM/YYYY - HH:mm:ss"));
            // wb.sheet(1).cell("G3").value(user);
            data.forEach((customer, index) => {
              wb.sheet(1)
                .cell(`C${index + 7}`)
                .value(parseInt(index + 1));
              if (
                customer.informacionAdicional &&
                customer.informacionAdicional.contrato
              ) {
                wb.sheet(1)
                  .cell(`D${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.informacionAdicional.contrato}`
                    )
                  );
              }
              if (customer.nombreSocio) {
                wb.sheet(1)
                  .cell(`E${index + 7}`)
                  .value(this.cleanString(`${customer.nombreSocio}`));
              }
              if (customer.rut) {
                wb.sheet(1)
                  .cell(`F${index + 7}`)
                  .value(this.cleanString(`${customer.rut}`));
              }
              if (customer.sexo) {
                wb.sheet(1)
                  .cell(`G${index + 7}`)
                  .value(this.cleanString(`${customer.sexo}`));
              }
              if (
                customer.informacionGeografica &&
                customer.informacionGeografica.direccion
              ) {
                wb.sheet(1)
                  .cell(`H${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.informacionGeografica.direccion}`
                    )
                  );
              }
              if (
                customer.informacionGeografica &&
                customer.informacionGeografica.ciudad
              ) {
                wb.sheet(1)
                  .cell(`I${index + 7}`)
                  .value(
                    this.cleanString(`${customer.informacionGeografica.ciudad}`)
                  );
              }
              if (
                customer.informacionGeografica &&
                customer.informacionGeografica.region
              ) {
                wb.sheet(1)
                  .cell(`J${index + 7}`)
                  .value(
                    this.cleanString(`${customer.informacionGeografica.region}`)
                  );
              }
              if (
                customer.informacionAdicional &&
                customer.informacionAdicional.comuna
              ) {
                wb.sheet(1)
                  .cell(`K${index + 7}`)
                  .value(
                    this.cleanString(`${customer.informacionAdicional.comuna}`)
                  );
              }
              if (
                customer.informacionContacto &&
                customer.informacionContacto.telefonoFijo
              ) {
                wb.sheet(1)
                  .cell(`L${index + 7}`)
                  .value(
                    parseInt(
                      this.cleanNum(
                        `${customer.informacionContacto.telefonoFijo}`
                      )
                    )
                  );
              }
              if (
                customer.informacionContacto &&
                customer.informacionContacto.celular
              ) {
                wb.sheet(1)
                  .cell(`M${index + 7}`)
                  .value(
                    parseInt(
                      this.cleanNum(`${customer.informacionContacto.celular}`)
                    )
                  );
              }
              if (customer.autenticacion && customer.autenticacion.email) {
                wb.sheet(1)
                  .cell(`N${index + 7}`)
                  .value(this.cleanEmail(`${customer.autenticacion.email}`));
              }
              if (customer.perfilCuenta && customer.perfilCuenta.glosa) {
                wb.sheet(1)
                  .cell(`O${index + 7}`)
                  .value(this.cleanString(`${customer.perfilCuenta}`));
              }
              if (
                customer.informacionAdicional &&
                customer.informacionAdicional.rutTitularConvenio
              ) {
                wb.sheet(1)
                  .cell(`P${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.informacionAdicional.rutTitularConvenio}`
                    )
                  );
              }
              if (customer.fechaInscripcion) {
                wb.sheet(1)
                  .cell(`Q${index + 7}`)
                  .value(
                    customer.fechaInscripcion
                      ? this.$moment(customer.fechaInscripcion).toDate()
                      : this.$moment("01-01-1900").toDate()
                  );
              }
              if (
                customer.informacionAdicional &&
                customer.informacionAdicional.accesoFicha
              ) {
                wb.sheet(1)
                  .cell(`R${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.informacionAdicional.accesoFicha}`
                    )
                  );
              }
              if (
                customer.informacionAdicional &&
                customer.informacionAdicional.causaBloqueo
              ) {
                wb.sheet(1)
                  .cell(`S${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.informacionAdicional.causaBloqueo}`
                    )
                  );
              }
              if (
                customer.informacionAdicional &&
                customer.informacionAdicional.fechaNacimiento
              ) {
                wb.sheet(1)
                  .cell(`T${index + 7}`)
                  .value(
                    this.$moment(
                      customer.informacionAdicional.fechaNacimiento
                    ).toDate()
                  );
              }
              if (
                customer.informacionContacto &&
                customer.informacionContacto.facebook
              ) {
                wb.sheet(1)
                  .cell(`U${index + 7}`)
                  .value(
                    this.cleanString(`${customer.informacionContacto.facebook}`)
                  );
              }
              if (
                customer.informacionContacto &&
                customer.informacionContacto.instagram
              ) {
                wb.sheet(1)
                  .cell(`V${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.informacionContacto.instagram}`
                    )
                  );
              }
              if (
                customer.informacionContacto &&
                (customer.informacionContacto.twitter ||
                  customer.informacionContacto.linkedin)
              ) {
                wb.sheet(1)
                  .cell(`W${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.informacionContacto.twitter}`
                    ) ||
                      this.cleanString(
                        `${customer.informacionContacto.linkedin}`
                      )
                  );
              }

              if (customer.planes.principal) {
                wb.sheet(1)
                  .cell(`AK${index + 7}`)
                  .value(
                    this.cleanString(`${customer.planes.principal.convenio}`)
                  );
                wb.sheet(1)
                  .cell(`AL${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.planes.principal.nombreFamilia}`
                    )
                  );
                wb.sheet(1)
                  .cell(`AM${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.planes.principal.nombreSubFamilia}`
                    )
                  );
                wb.sheet(1)
                  .cell(`AN${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.planes.principal.descripcionPlan}`
                    )
                  );
                wb.sheet(1)
                  .cell(`AO${index + 7}`)
                  .value(
                    `${parseFloat(customer.planes.principal.valorPlan)}` || "0"
                  );
                wb.sheet(1)
                  .cell(`AP${index + 7}`)
                  .value(
                    customer.planes.principal.indicadorMatricula ? "SI" : "NO"
                  );
                // .value(customer.planes.principal.indicadorMatricula ? 1 : 0);
                wb.sheet(1)
                  .cell(`AQ${index + 7}`)
                  .value(parseFloat(customer.planes.principal.valorMatricula));
                if (customer.planes.principal.fechaUltimoPago) {
                  wb.sheet(1)
                    .cell(`AR${index + 7}`)
                    .value(
                      customer.planes.principal.fechaUltimoPago
                        ? this.$moment(
                            customer.planes.principal.fechaUltimoPago,
                            "DD-MM-YYYY"
                          ).toDate()
                        : this.$moment("01-01-1900").toDate()
                    );
                }
                wb.sheet(1)
                  .cell(`AS${index + 7}`)
                  .value(
                    parseFloat(customer.planes.principal.porcentajeDescuento) ||
                      0
                  );
                wb.sheet(1)
                  .cell(`AT${index + 7}`)
                  .value(
                    customer.planes.principal.indicadorFactura ? "SI" : "NO"
                  );
                wb.sheet(1)
                  .cell(`AU${index + 7}`)
                  // .value(customer.planes.principal.tipoIVA);
                  .value(
                    this.cleanString(`${customer.planes.principal.tipoIVA}`)
                  );
                wb.sheet(1)
                  .cell(`AV${index + 7}`)
                  .value(
                    this.cleanString(`${customer.planes.principal.estadoPago}`)
                  );
                wb.sheet(1)
                  .cell(`AW${index + 7}`)
                  .value(
                    customer.planes.principal.fechaAsignacion
                      ? this.$moment(
                          customer.planes.principal.fechaAsignacion
                        ).toDate()
                      : this.$moment("01-01-1900").toDate()
                  );
                wb.sheet(1)
                  .cell(`AX${index + 7}`)
                  .value(
                    customer.planes.principal.fechaInicio
                      ? this.$moment(
                          customer.planes.principal.fechaInicio,
                          "DD-MM-YYYY"
                        ).toDate()
                      : this.$moment("01-01-1900").toDate()
                  );
                // console.log("vencimiento");
                // console.log(
                //   customer.planes.principal.fechaVencimiento || "sin datos"
                // );
                wb.sheet(1)
                  .cell(`AY${index + 7}`)
                  .value(
                    customer.planes.principal.fechaVencimiento
                      ? this.$moment(
                          customer.planes.principal.fechaVencimiento,
                          "DD-MM-YYYY"
                        ).toDate()
                      : this.$moment("01-01-1900", "DD-MM-YYYY").toDate()
                  );
                // console.log("vigencia");
                // console.log(
                //   customer.planes.principal.fechaVigencia || "sin datos"
                // );
                wb.sheet(1)
                  .cell(`AZ${index + 7}`)
                  .value(
                    customer.planes.principal.fechaVigencia
                      ? this.$moment(
                          customer.planes.principal.fechaVigencia,
                          "DD-MM-YYYY"
                        ).toDate()
                      : this.$moment("01-01-1900").toDate()
                  );
                wb.sheet(1)
                  .cell(`BA${index + 7}`)
                  .value(
                    customer.planes.principal.fechaUltimoPago
                      ? this.$moment(
                          customer.planes.principal.fechaUltimoPago,
                          "DD-MM-YYYY"
                        ).toDate()
                      : this.$moment("01-01-1900")
                  );
                wb.sheet(1)
                  .cell(`BB${index + 7}`)
                  .value(
                    customer.planes.principal.horaUltimoPago || "00:00:00"
                  );
                wb.sheet(1)
                  .cell(`BC${index + 7}`)
                  .value(parseInt(customer.planes.principal.duracionPlan) || 0);
                wb.sheet(1)
                  .cell(`BD${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.planes.principal.unidadDuracionPlan}`
                    )
                  );
                wb.sheet(1)
                  .cell(`BE${index + 7}`)
                  .value(
                    customer.planes.principal.indicadorMesCalendario
                      ? "SI"
                      : "NO"
                  );
                wb.sheet(1)
                  .cell(`BF${index + 7}`)
                  .value(
                    customer.planes.principal.indicadorUsoSesiones ? "SI" : "NO"
                  );
                wb.sheet(1)
                  .cell(`BG${index + 7}`)
                  .value(
                    parseInt(customer.planes.principal.sesionesUtilizadas) || 0
                  );
                wb.sheet(1)
                  .cell(`BH${index + 7}`)
                  .value(
                    parseInt(customer.planes.principal.sesionesLimite) || 0
                  );
                wb.sheet(1)
                  .cell(`BI${index + 7}`)
                  .value(
                    customer.planes.principal.indicadorPermiteRenovar
                      ? "SI"
                      : "NO"
                  );
                wb.sheet(1)
                  .cell(`BJ${index + 7}`)
                  .value(
                    parseInt(customer.planes.principal.expiracionRenovacion) ||
                      0
                  );
                wb.sheet(1)
                  .cell(`BK${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.planes.principal.unidadExpiracionRenovacion}`
                    )
                  );
                wb.sheet(1)
                  .cell(`BL${index + 7}`)
                  .value(
                    parseInt(customer.planes.principal.diasPermitidoCongelar) ||
                      0
                  );
                wb.sheet(1)
                  .cell(`BM${index + 7}`)
                  .value(`${customer.planes.principal.turno.idTurno}` || "0");
                if (customer.planes.principal.sucursalUltimoPago) {
                  wb.sheet(1)
                    .cell(`BN${index + 7}`)
                    .value(
                      this.cleanString(
                        `${customer.planes.principal.sucursalUltimoPago}`
                      )
                    );
                }
                if (customer.planes.principal.fechaHoraUltimoAcceso) {
                  wb.sheet(1)
                    .cell(`BO${index + 7}`)
                    .value(
                      customer.planes.principal.fechaHoraUltimoAcceso
                        ? this.$moment(
                            customer.planes.principal.fechaHoraUltimoAcceso,
                            "DD-MM-YYYY"
                          ).toDate()
                        : this.$moment("01-01-1900").toDate()
                    );
                }
                wb.sheet(1)
                  .cell(`BP${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.planes.principal.nombreSucursalAsignacion}`
                    )
                  );
                wb.sheet(1)
                  .cell(`BQ${index + 7}`)
                  .value(
                    this.cleanString(
                      `${customer.planes.principal.nombreUsuarioAsignacion}`
                    )
                  );
              }
            });
            // const sheet = wb.sheet(1);
            // sheet.sheetProtection().password("@#soporte.2024");
            wb.outputAsync().then((blob) => {
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(
                  blob,
                  `Exportasión de Membresías A.M.M.[${this.$moment().format(
                    "DD-MM-yyyy - HH-mm-ss"
                  )}].xlsx`
                );
              } else {
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = url;
                a.download = `Exportasión de Membresías A.M.M.[${this.$moment().format(
                  "DD-MM-yyyy - HH-mm-ss"
                )}].xlsx`;
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
              }
              this.$swal.close();
              this.$swal.fire({
                title: "Exito!",
                text: "La exportasión se ha completado forma exitosa",
                icon: "success",
                confirmButtonColor: "#6bd098",
              });
            });
          })
          .catch((error) => {
            console.error(error);
            this.$swal
              .fire({
                title: "Error!",
                text:
                  error.message ||
                  "Ha ocurrido un error durante la renderización del respaldo",
                confirmButtonColor: "#6bd098",
                icon: "error",
              })
              .then(() => {
                return { completed: false };
              });
          });
      } catch (error) {
        this.$swal
          .fire({
            title: "Error!",
            text:
              error.message ||
              "Ha ocurrido un error durante la renderización del respaldo",
            confirmButtonColor: "#6bd098",
            icon: "error",
          })
          .then(() => {
            return { completed: false };
          });
      } finally {
        this.reportData = [];
      }
    },
    async fetchExcelTemplate(templateName) {
      const template = templateName;
      try {
        const response = await this.$XLSXTemplateDownload.post(
          "",
          {
            template: template,
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
            },
            responseType: "arraybuffer",
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error al cargar el archivo xlsx:", error);
        return {
          error:
            error.message ||
            `Ha ocurrido un error inesperado al recuperar la plantilla excel`,
        };
      }
    },
    async createReportData(isBackup) {
      let query = _.cloneDeep(this.queryFilters);
      if (isBackup) {
        query.editList = this.currentEditInclusion.editList;
        query.editAll = this.currentEditInclusion.editAll;
      } else {
        query.editList = [];
        query.editAll = true;
      }
      query.preview = true;
      let keepFetching = true;
      let page = 0;
      let currentResponse;
      let error;
      do {
        try {
          currentResponse = await this.$MasterControlAPP.post(
            "",
            {
              Parameters: {
                page: page,
                ...query,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/fetch/filtered/memberships/reportformat",
                // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                //   .AccessStatistics,
              },
            }
          );
          if (currentResponse.data.error) {
            keepFetching = false;
            this.$swal.fire({
              title: "Error!",
              text: currentResponse.data.error,
              confirmButtonColor: "#6bd098",
            });
          } else {
            const fetchedData = currentResponse.data.result;
            if (fetchedData) {
              this.reportData.push(...fetchedData);
            }
            // console.log(`Resultado pagina: ${page}`);
            // console.log(`Resultado skip: ${currentResponse.data.skip}`);
            // console.log(fetchedData);
            // console.log(
            //   !!fetchedData.length
            //     ? "Seguimos"
            //     : "No seguimos nah"
            // );
            // fetchedData.forEach((i) => console.log(i.rut));
            keepFetching = !!fetchedData.length;
            page++;
          }
        } catch (error) {
          keepFetching = false;
          error = error;
          console.error(error);
        }
      } while (keepFetching);
      if (this.reportData && !error) {
        return this.reportData;
      } else if (error) {
        return {
          error:
            error.message ||
            "Ha ocurrido un error inesperado durante la consulta de datos para generar el reporte",
        };
      } else {
        return { error: "La consulta no retornó datos para generar reporte" };
      }
    },
    handleBulkMembershipUpdate() {
      let backupCompleted = false;
      this.$swal
        .fire({
          icon: "warning",
          title: "Confirmación de Actualización Masiva",
          html: '<p class="mb-2">Esta herramienta realiza cambios significativos.</p><p class="mb-2">Asegúrate de entender las consecuencias de estas modificaciones.</p><p clas="mb-2">CentralGym no se hace responsable del mal uso de esta herramienta</p>',
          input: "checkbox",
          inputValue: false,
          inputPlaceholder:
            "Confirmo que he revisado los cambios y acepto la responsabilidad por la actualización",
          showCancelButton: true,
          confirmButtonColor: "#6bd098",
          cancelButtonColor: "#ef8157",
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
          inputValidator: (value) => {
            if (!value) {
              return "Debes confirmar marcando la casilla antes de continuar.";
            }
          },
          preConfirm: async (val) => {
            console.log("Comenzando renderizado de backup");
            if (val) {
              await this.renderAMMBackup()
                .then((res) => {
                  // console.log(res);
                  console.log("Renderizado completo");
                  backupCompleted = res.completed;
                })
                .catch(() => {
                  return "error";
                });
            }
          },
        })
        .then(async (res) => {
          // console.log(res);
          if (res.isConfirmed) {
            console.log("Comenzando actualización masivar");
            if (backupCompleted === true) {
              await this.bulkMembershipUpdate().then(() => {
                console.log("Actualización completada");
                this.$swal
                  .fire({
                    title: "Exito!",
                    text: "La actualización se ha realizado con exito, recuerda guardar tu archivo de Backup",
                    icon: "success",
                    confirmButtonColor: "#6bd098",
                  })
                  .then(() => {
                    this.$swal.fire({
                      title: "Cargando",
                      text: "Un segundo por favor...",
                      allowOutsideClick: false,
                      showConfirmButton: false,
                      didOpen: () => {
                        this.$swal.showLoading();
                      },
                    });
                    // window.location.reload();
                    // this.$router.push('/customers&memberships/membershipsAdm')
                    const currentPath = this.$route.path;
                    this.$router.replace("/dummy").then(() => {
                      this.$router.replace(currentPath);
                    });
                  });
              });
            } else {
              this.$swal.fire({
                icon: "warning",
                title: "Ejecución Interrumpida",
                text: "La creación del archivo de respaldo no se completó correctamente. Por favor, verifica el estado de la red y vuelve a intentarlo.",
                confirmButtonColor: "#6bd098",
              });
            }
          }
        });
    },
    async bulkMembershipUpdate() {
      // this.$refs.alertComponent.toggleShowingData(null);
      // this.$refs.alertComponent.togglePreviewIsLoading(true);
      // this.previewData = {};
      // this.compareData = {};
      this.$swal.fire({
        title: "Cargando",
        text: "Espera un momento...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      const currentEditInclusion = _.cloneDeep(this.currentEditInclusion);
      var query = _.cloneDeep(this.queryFilters);
      query.editList = currentEditInclusion.editList;
      query.editAll = currentEditInclusion.editAll;
      var edit = _.cloneDeep(this.editData);

      var edit = _.cloneDeep(this.editData);
      // console.log("edit********");
      // console.log(edit);
      // console.log("edit********");
      // console.log("query********");
      // console.log(query);
      // console.log("query********");
      // console.log(this.editData);
      // console.log(query);

      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {
                ...query,
              },
              Body: { ...edit },
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/update/filtered/memberships",
              },
            }
          )
          .then((res) => {
            this.$refs.alertComponent.togglePreviewIsLoading(false);
            // console.log("OK");
            // console.log(res);
            // console.log("OK");
            if (res.data) {
              if (res.data.error) {
                this.$swal.close();
                this.$swal.fire({
                  title: "Error! :(",
                  text: res.data.error,
                  icon: "error",
                  confirmButtonColor: `#6bd098`,
                });
              } else {
                this.$swal.close();
                // console.log("**result**");
                // console.log(res.data);
                this.previewData = res.data;
              }
            } else {
              this.$swal.close();
              this.$swal.fire({
                title: "Error! :(",
                text: "Ha ocurrido un error inesperado, vuelve a intentar más tarde o ponte en contacto con soporte",
                icon: "error",
                confirmButtonColor: `#6bd098`,
              });
            }
          });
      } catch (error) {
        console.error("catch [fetchMembershipsPage]");
        console.error(error);
        this.$swal.close();
        this.$swal.fire({
          title: "Error! :(",
          text: `${
            error.message || "Error inesperado"
          } - Por favor intentalo mas tarde o ponte en contacto con soporte`,
          icon: "error",
          confirmButtonColor: `#6bd098`,
        });
        this.$refs.alertComponent.togglePreviewIsLoading(false);
      }
    },
    async previewSingle(nid) {
      this.$refs.alertComponent.toggleShowingData(null);
      this.$refs.alertComponent.togglePreviewIsLoading(true);
      this.previewData = {};
      this.compareData = {};
      this.$swal.fire({
        title: "Cargando",
        text: "Espera un momento...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      var query = _.cloneDeep(this.queryFilters);
      query.editList = [nid];
      query.editAll = false;
      query.preview = true;

      var edit = _.cloneDeep(this.editData);
      // console.log("edit********");
      // console.log(edit);
      // console.log("edit********");
      // console.log(this.editData);
      // console.log(query);

      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {
                ...query,
              },
              Body: { ...edit },
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/update/filtered/memberships",
              },
            }
          )
          .then((res) => {
            const alertComponent = this.$refs.alertComponent;
            alertComponent.togglePreviewIsLoading(false);
            // console.log("OK");
            // console.log(res);
            if (res.data) {
              if (res.data.error) {
                this.$swal.close();
                this.$swal.fire({
                  title: "Error! :(",
                  text: res.data.error,
                  icon: "error",
                  confirmButtonColor: `#6bd098`,
                });
              } else {
                this.$swal.close();
                // console.log("**PREVIEW**");
                // console.log(res.data.preview[0]);
                this.previewData = res.data.preview[0];
                // console.log("**COMPARE**");
                // console.log(res.data.compare[0]);
                this.compareData = res.data.compare[0];
                alertComponent.toggleShowingData(1);
                alertComponent.confirmCounterAdd();
              }
            } else {
              this.$swal.close();
              this.$swal.fire({
                title: "Error! :(",
                text: "Ha ocurrido un error inesperado, vuelve a intentar más tarde o ponte en contacto con soporte",
                icon: "error",
                confirmButtonColor: `#6bd098`,
              });
            }
          });
      } catch (error) {
        console.error("catch [fetchMembershipsPage]");
        console.error(error);
        this.$swal.close();
        this.$swal.fire({
          title: "Error! :(",
          text: `${
            error.message || "Error inesperado"
          } - Por favor intentalo mas tarde o ponte en contacto con soporte`,
          icon: "error",
          confirmButtonColor: `#6bd098`,
        });
        this.$refs.alertComponent.togglePreviewIsLoading(false);
      }
    },
    handleEditContinue(edit, editShift) {
      var editBody = { ...edit };
      if (editShift) {
        let { id, ...shiftData } = this.selectedShift;
        // console.log("this.selectedShift");
        // console.log(shiftData);
        shiftData.idTurno = id;
        editBody.shift = shiftData;
      }

      this.editData = editBody;
      this.showAlert = true;
      if (this.currentEditInclusion.editAll) {
        this.currentEditInclusion.editList = this.showingMemberships.map(
          (i) => i.rutSocio
        );
        // console.log(this.currentEditInclusion);
      }
      this.$nextTick(() => {
        const alertComponent = this.$refs.alertComponent.$el;
        if (alertComponent) {
          alertComponent.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        } else {
          // console.log("blip");
        }
      });
    },
    editSelectedShift() {
      // console.log("editando turno seleccionado");
      this.$refs.shiftUpdateModal.showModal();
    },
    shiftHandleSaveChanges(data) {
      this.selectedShift = data;
    },
    shiftUpdateModalClose() {
      this.$refs.shiftSelectModal.closeModal();
    },
    shiftUpdateModalStepBack(shiftOG) {
      this.selectedShift = _.cloneDeep(shiftOG);
      // this.$refs.editorComponent.editShiftClose();
      this.$refs.shiftSelectModal.showModal();
    },
    disableShiftEdit(shiftOG) {
      this.selectedShift = _.cloneDeep(shiftOG);
    },
    shiftSelectModalClose() {
      // console.log("closed parent");
      this.$refs.editorComponent.editShiftClose();
    },
    handleShowShiftDetails(shift) {
      this.$refs.shiftSelectModal.closeModal();
      this.selectedShift = _.cloneDeep(shift);
      this.$refs.shiftUpdateModal.showModal();
    },
    handleSaveShiftSelection(shift) {
      this.selectedShift = shift;
      this.$refs.shiftSelectModal.closeModal();
    },
    toggleShiftSelect(state) {
      if (state) {
        this.$refs.shiftSelectModal.showModal();
      } else {
        this.selectedShift = {};
      }
    },
    async getShift(id) {
      let response;
      // console.log("iniciando GetShift: ", id);
      try {
        response = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: { shift: id },
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/get/shift",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")).MembershipsStatistics,
            },
          }
        );

        // console.log(response.data.result);
        return response.data.result;
      } catch (error) {
        console.error("Error");
        console.error(error);
      }
    },
    async getShiftResum() {
      this.shifts = [];
      let response;
      try {
        response = await this.$MasterControlAPP.post(
          "",
          {
            Parameters: {},
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: sessionStorage.getItem("jCxbraoQeD"),
              operation: "/v1/get/shift/resum",
              // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q")).MembershipsStatistics,
            },
          }
        );
        if (response.data.result && response.data.result.length > 0) {
          // console.log(response.data.result)
          response.data.result.forEach((shift) => {
            this.shiftsCatalog.push(shift);
          });
        }
      } catch (error) {
        console.error("Error");
        console.error(error);
      }
    },
    async activateEditor() {
      this.showEditor = true;
      try {
        await this.getShiftResum();
      } catch (error) {
        this.$swal.fire({
          title: "Error! :(",
          text: `${
            error.message || "Error inesperado"
          } - Por favor intentalo mas tarde o ponte en contacto con soporte`,
          icon: "error",
          confirmButtonColor: `#6bd098`,
        });
      }
      this.$nextTick(() => {
        const editorComponent = this.$refs.editorComponent.$el;
        if (editorComponent) {
          editorComponent.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        } else {
          // console.log("blip");
        }
      });
    },
    async refreshTable() {
      const filtersComponent = this.$refs.filtersComponent;
      if (filtersComponent) {
        await filtersComponent.updateFilter();
        // console.log("actualizado");
      }
    },
    updatedCurrentEditExclusion(arg) {
      // console.log('klñdksldsa')
      this.currentEditInclusion = {
        editAll: arg.editAll,
        editList: arg.editList,
      };
      const alertComponent = this.$refs.alertComponent;
      if (alertComponent) {
        const editorComponent = this.$refs.editorComponent;
        alertComponent.close();
        this.showAlert = false;
        if (editorComponent) {
          editorComponent.toggleWasModified(true);
        }
      }
    },
    handleUpdateCurrentFilters(arg) {
      let formatedStatus = [];
      let formatedPlan = [];
      let formatedfamily = [];
      let formatedSubfamily = [];
      let formatedShift = [];
      let formatedBranches = [];
      if (arg.plan.length > 0) {
        arg.plan.forEach((i) => {
          const plan = this.plansCatalog.filter((cat) => cat._id === i);
          formatedPlan.push(plan[0].nombre);
        });
        arg.plan = formatedPlan;
      }
      if (arg.family.length > 0) {
        arg.family.forEach((i) => {
          const family = this.familiesCatalog.filter((cat) => cat._id === i);
          formatedfamily.push(family[0].nombre);
        });
        arg.family = formatedfamily;
      }
      if (arg.subFamily.length > 0) {
        arg.subFamily.forEach((i) => {
          const subFamily = this.subFamiliesCatalog.filter(
            (cat) => cat._id === i
          );
          formatedSubfamily.push(subFamily[0].nombre);
        });
        arg.subFamily = formatedSubfamily;
      }
      if (arg.shift.length > 0) {
        arg.shift.forEach((i) => {
          const shift = this.shiftsCatalogFromMemberships.filter(
            (cat) => cat._id === i
          );
          formatedShift.push(shift[0].nombre);
        });
        arg.shift = formatedShift;
      }
      if (arg.branches.length > 0) {
        arg.branches.forEach((i) => {
          const branches = this.branches.filter((cat) => cat._id === i);
          formatedBranches.push(branches[0].nombreSucursal);
        });
        arg.branches = formatedBranches;
      }
      const editorComponent = this.$refs.editorComponent;

      if (editorComponent) {
        editorComponent.clean();
      }

      this.currentQueryFilters = arg;
      this.tableIsUpdated = false;
      this.showEditor = false;
      this.showAlert = false;
    },
    async handleFetchByScroll() {
      if (this.keepFetchingData) {
        try {
          await this.fetchMembershipsPage().then(() => {
            this.tableCurrentPage++;
          });
        } catch (error) {
          console.error("catch [handleFetchByScroll]");
          console.error(error);
          this.$swal.close();
          this.$swal.fire({
            title: "Error! :(",
            text: `${
              error.message || "Error inesperado"
            } - Por favor intentalo mas tarde o ponte en contacto con soporte`,
            icon: "error",
            confirmButtonColor: `#6bd098`,
          });
        }
      }
    },
    async getCatalog() {
      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {},
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/fetch/filtered/memberships/catalogs",
                // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                //   .AccessStatistics,
              },
            }
          )
          .then((res) => {
            if (res.data) {
              if (res.data.error) {
                console.error(res.data.error);
                this.$swal.close();
                this.$swal.fire({
                  title: "Error! :(",
                  text: `${
                    res.data.error || "Error inesperado"
                  } - Por favor intentalo mas tarde o ponte en contacto con soporte`,
                  icon: "error",
                  confirmButtonColor: `#6bd098`,
                });
              } else {
                this.plansCatalog = res.data.plans;
                this.statusCatalog = res.data.status;
                this.familiesCatalog = res.data.families;
                this.subFamiliesCatalog = res.data.subFamilies;
                this.shiftsCatalogFromMemberships = res.data.shifts;
                // console.log(res.data);
              }
            } else {
              this.$swal.close();
              this.$swal.fire({
                title: "Error! :(",
                text: `Error inesperado - Por favor intentalo mas tarde o ponte en contacto con soporte`,
                icon: "error",
                confirmButtonColor: `#6bd098`,
              });
            }
          });
        // console.log(catalog.data.documents);
        // console.log("this.pagination.catalog*************");
        // console.log(catalog);
      } catch (ex) {
        console.error("Error: [getCatalog]");
        console.error(ex);
        this.$swal.close();
        this.$swal.fire({
          title: "Error! :(",
          text: `Ha ocurrido un error al recuperar los catalogos, vuelve a intentarlo mas tarde o si ponte en contacto con soporte`,
          icon: "error",
          confirmButtonColor: `#6bd098`,
        });
      }
    },
    async fetchCatalogDictionary() {
      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {},
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/fetch/catalog/dictionary",
                // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                //   .AccessStatistics,
              },
            }
          )
          .then((res) => {
            if (res.data.error) {
              this.$swal.fire({
                title: "Error! :(",
                text: res.data.error,
                icon: "error",
                confirmButtonColor: `#6bd098`,
              });
            } else {
              // console.log(res.data);
              this.catalogDictionary = res.data.result;
            }
          });
      } catch (error) {
        this.$swal.fire({
          title: "Error! :(",
          text: `${
            error.message || "Error inesperado"
          } - Por favor intentalo mas tarde o ponte en contacto con soporte`,
          icon: "error",
          confirmButtonColor: `#6bd098`,
        });
      } finally {
        // console.log(this.catalogDictionary);
      }
    },
    async handleUpdateFilters(filters) {
      // console.log(filters);
      this.tableCurrentPage = 0;
      this.showingMemberships = [];
      this.queryFilters = filters;
      try {
        await this.fetchMembershipsPage().then(() => {
          this.tableCurrentPage++;
          const tableComponent = this.$refs.membershipsTable;
          if (tableComponent) {
            tableComponent.clearEditSelection();
            tableComponent.$el.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        });
        await this.countFilteredMemberships().then(() => {});
        this.$swal.close();
      } catch (error) {
        console.error("catch [handleUpdateFilters]");
        console.error(error);
        this.$swal.close();
        this.$swal.fire({
          title: "Error! :(",
          text: `${
            error.message || "Error inesperado"
          } - Por favor intentalo mas tarde o ponte en contacto con soporte`,
          icon: "error",
          confirmButtonColor: `#6bd098`,
        });
      }
    },
    async fetchMembershipsPage() {
      this.$swal.fire({
        title: "Cargando",
        text: "Espera un momento...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {
                page: this.tableCurrentPage,
                ...this.queryFilters,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/fetch/filtered/memberships",
                // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                //   .AccessStatistics,
              },
            }
          )
          .then((res) => {
            // console.log("OK");
            // console.log(res);
            if (res.data) {
              if (res.data.error) {
                this.$swal.close();
                this.$swal.fire({
                  title: "Error! :(",
                  text: res.data.error,
                  icon: "error",
                  confirmButtonColor: `#6bd098`,
                });
              } else {
                this.tableIsUpdated = true;
                const fetchedData = res.data.result;
                this.showingMemberships.push(...fetchedData);
                // console.log(this.showingMemberships);
                this.keepFetchingData = fetchedData.length === 20;
                this.$swal.close();
              }
            } else {
              this.$swal.close();
              this.$swal.fire({
                title: "Error! :(",
                text: "Ha ocurrido un error inesperado, vuelve a intentar más tarde o ponte en contacto con soporte",
                icon: "error",
                confirmButtonColor: `#6bd098`,
              });
            }
          });
      } catch (error) {
        console.error("catch [fetchMembershipsPage]");
        console.error(error);
        this.$swal.close();
        this.$swal.fire({
          title: "Error! :(",
          text: `${
            error.message || "Error inesperado"
          } - Por favor intentalo mas tarde o ponte en contacto con soporte`,
          icon: "error",
          confirmButtonColor: `#6bd098`,
        });
      }
    },
    async countFilteredMemberships() {
      this.$swal.fire({
        title: "Cargando",
        text: "Espera un momento...",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {
                page: this.tableCurrentPage,
                ...this.queryFilters,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/count/filtered/memberships",
                // operation: JSON.parse(sessionStorage.getItem("wxZlBbdD4q"))
                //   .AccessStatistics,
              },
            }
          )
          .then((res) => {
            // console.log("OK");
            // console.log(res);
            if (res.data) {
              if (res.data.error) {
                this.$swal.close();
                this.$swal.fire({
                  title: "Error! :(",
                  text: res.data.error,
                  icon: "error",
                  confirmButtonColor: `#6bd098`,
                });
              } else {
                this.filteredMembershipsCount = res.data.total;
                return;
              }
            } else {
              this.$swal.close();
              this.$swal.fire({
                title: "Error! :(",
                text: "Ha ocurrido en error inesperado, vuelve a intentarlo más tarde o ponte en contacto con soporte",
                icon: "error",
                confirmButtonColor: `#6bd098`,
              });
            }
          });
      } catch (error) {
        console.error("catch [countFilteredMemberships]");
        console.error(error);
        this.$swal.close();
        this.$swal.fire({
          title: "Error! :(",
          text: `${
            error.message || "Error inesperado"
          } - Por favor vuelve a intentarlo mas tarde o ponte en contacto con soporte`,
          icon: "error",
          confirmButtonColor: `#6bd098`,
        });
      }
    },
  },
  async beforeMount() {
    this.$swal.fire({
      title: "Cargando!",
      text: "Espera un momento...",
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        this.$swal.showLoading();
      },
    });
    try {
      await this.getCatalog();
      await this.fetchCatalogDictionary();
      this.$swal.close();
    } catch (error) {
      this.$swal.close();
      this.$swal.fire({
        title: "Error! :(",
        text: `${
          error.message || "Error inesperado"
        } - Vuelve a intentarlo mas tarde o si ponte en contacto con soporte`,
        icon: "error",
        confirmButtonColor: `#6bd098`,
      });
    }
    return;
  },
  async mounted() {
    this.branches = JSON.parse(sessionStorage.getItem("xxxwypt5ip"));
    this.$nextTick(async () => {
      try {
        await this.fetchMembershipsPage().then(() => {
          this.tableCurrentPage++;
        });
        await this.countFilteredMemberships();
        this.$swal.close();
      } catch (error) {
        console.error("catch [handleUpdateFilters]");
        console.error(error);
        this.$swal.close();
        this.$swal.fire({
          title: "Error! :(",
          text: `${
            error.message || "Error inesperado"
          } - Por favor intentalo mas tarde o ponte en contacto con soporte`,
          icon: "error",
          confirmButtonColor: `#6bd098`,
        });
      }
    });
  },
};
</script>

<style></style>
